import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Button, Tooltip } from "@mui/material";
import { withRouter } from "../../../providers/withRouter";
import { UsuarioContext } from "../../../providers/userContext";
import { DataTable, LaeButton, ProgressBarWithColors } from "../../../components";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import FiltrosAAFF from "../../../components/filtros/filtrosAAFF";
import { editarAAFF, asignarTecnico, asignarConsultor, asignarComercial, filterAAFFs, loginAsAAFF } from "../../../services";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Add from "../../../icons/add.svg";
import Tick from "../../../icons/tick.svg";
import criticalWarning from "../../../icons/criticalWarning.svg";
import Warning from "../../../icons/warning.svg";
import newSupp from "../../../icons/new_supp_green.svg";
import New from "../../../icons/new.svg";
import { Login } from '@mui/icons-material';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import { MdOutlineFiberNew } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import { te } from "date-fns/locale";

const AAFF = () => {
  const { t } = useTranslation('aaff');
  const user = useContext(UsuarioContext);
  //   const { loading, data, setPagination, pagination, fetchData } = useAAFFs();
  const [loading, setLoading] = useState(true);

  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();

  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [recargar, setRecargar] = useState(false);


  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [data, setData] = useState(
    {
      meta: {},
      rows: []
    });
  const [primeraCarga, setPrimeraCarga] = useState(true);
  const refControladorAborto = useRef(null);


  const navigate = useNavigate();

  const location = useLocation();

 
  

  const clearFilters = () => {
    if (user.rol === "CONSUL" && localStorage.getItem("hasReloaded") === "true") {
      setBusqueda({
        consul_id: user.id 
      });
    }
    else if(user.rol === "CONSUL"){
      setBusqueda({
        consul_id: user.id 
      });
    }
    else{
      setBusqueda({});
    }
    
    setClearFilterActivo(true);
  }

  const fetchData = async ({ offset, limit, filtros = busqueda, order, orderBy } = {}) => {
    if (refControladorAborto.current) {
      refControladorAborto.current.abort();
    }
    const nuevoControladorAborto = new AbortController();
    refControladorAborto.current = nuevoControladorAborto;

    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order = order || filtroOrder.orden || 'ASC';


    if (primeraCarga) {
      if (filtros.consul_id === undefined && user.rol === 'CONSUL') {
        filtros.consul_id = user.id;
      } else if (filtros.consul_id === "0") {
        delete filtros.consul_id;
      }
      setPrimeraCarga(false);
    }


    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy);

    // setOrder(sortOrder);
    // setOrderBy(sortBy);

    const payload = { filtros, params: { page: offset, limit: limit, order, orderBy }, signal: nuevoControladorAborto.signal };

    try {
      setLoading(true);
      const response = await filterAAFFs(payload, { signal: nuevoControladorAborto.signal });
      if (!nuevoControladorAborto.signal.aborted) {
        const { meta, data } = response;
        setData({
          meta,
          rows: formatData(data),
        });
      }
    } catch (error) {
      if (error.name === 'AbortError' || error.name === 'CanceledError') {
      } else {
        console.log(error);
      }
    } finally {
      if (refControladorAborto.current === nuevoControladorAborto) {
        setLoading(false);
      }
    }
  };

  function reasignar(a, b, c) {
    
    if (b === "consultor") {
      b = `consultor/${c}`;
    }
    if (b === "tecnico") {
      b = `tecnico/${c}`;
    }
    Swal.fire({
      title: b === "consultor" ? "consultor" : "tecnico" ? "tecnico" : `${t('actions.change')} ${b}?`,
      showDenyButton: b === "comercial" ? false : true,
      showCancelButton: true,
      confirmButtonText: t('actions.change'),
      denyButtonText: t('actions.unassign'),
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.replace("/aaff/" + a.nif + "/" + b);
      } else if (result.isDenied) {
        let desasignarPromesa;
        switch (b) {
          case `tecnico/${c}`:
            desasignarPromesa = asignarTecnico(a.nif, null, c);
            break;
          case `consultor/${c}`:
            desasignarPromesa = asignarConsultor(a.id, null, c);
            break;
          case "comercial":
            desasignarPromesa = asignarComercial(a.nif, null);
            break;
          default:
            desasignarPromesa = Promise.resolve();
        }

        desasignarPromesa.then(() => {
          const camposPorAccion = {
            'tecnico/1': { campo: 'tecnicoCae', etiqueta: 'tecnico Cae' },
            'tecnico/3': { campo: 'tecnicoCai', etiqueta: 'tecnico Cai' },
            'tecnico/4': { campo: 'tecnicoKae', etiqueta: 'tecnico Kae' },
            'consultor/1': { campo: 'consultorCae', etiqueta: 'consultor Cae' },
            'consultor/2': { campo: 'consultorLopd', etiqueta: 'consultor Lopd' },
            'comercial': { campo: 'comercial', etiqueta: 'comercial' },
          };
          const { campo, etiqueta } = camposPorAccion[b] || {};
          const prevLista = data.rows.map((item) => {
            if ((a.nif === item.nif || a.id === item.id) && campo) {
              return { ...item, [campo]: "" };
            }
            return item;
          });
          setData({ meta: data.meta, rows: prevLista });
          toast.success((etiqueta || b) + " " + t('messages.unassigned'));
        }).catch(error => {
          console.log(error);
          toast.error(t('messages.errorUnassign') + " " + b);
        });
      }
    });
  }

  const formatData = (data) => {
    return data.map((row) => {
      const consultorCae = row.consultants?.find(objeto => objeto?.r_consul_servsgroups_aaffs.some(group => group.group_id === 1));
      const consultorLopd = row.consultants?.find(objeto => objeto?.r_consul_servsgroups_aaffs.some(group => group.group_id === 2));
      const tecnicoCae = row.technicians?.find(objeto => objeto?.r_tech_aaffs.some(group => group.group_id === 1));
      const tecnicoCai = row.technicians?.find(objeto => objeto?.r_tech_aaffs.some(group => group.group_id === 3));
      const tecnicoKae = row.technicians?.find(objeto => objeto?.r_tech_aaffs.some(group => group.group_id === 4));
      return {
        razonSocial: row.razonSocial || row.nombreContacto,
        nif: row.nif,
        // fechaEncargo: row.fechaEncargo || '',
        id: row.id,
        pendientesCount: row.pendientesCount,
        visitadasCount: row.visitadasCount,
        renovadasCount: row.renovadasCount,
        renovadasVisitadasCount: row.renovadasVisitadasCount,
        comunidadesVisitadas: row.visitadasCount / (row.pendientesCount + (row.visitadasCount || 1)) * 100 ?? 0,
        comunidadesRenovasVisitadas: row.renovadasVisitadasCount / (row.renovadasCount + (row.renovadasVisitadasCount || 1)) * 100 ?? 0,
        consultorCae: consultorCae ? `${consultorCae.nombre} ${consultorCae.apellidos}` : "",
        consultorLopd: consultorLopd ? `${consultorLopd.nombre} ${consultorLopd.apellidos}` : "",
        tecnicoCae: tecnicoCae ? `${tecnicoCae.nombre} ${tecnicoCae.apellidos}` : "",
        tecnicoCai: tecnicoCai ? `${tecnicoCai.nombre} ${tecnicoCai.apellidos}` : "",
        tecnicoKae: tecnicoKae ? `${tecnicoKae.nombre} ${tecnicoKae.apellidos}` : "",
        // tecnico: row.technician?.id ? row.technician?.nombre + " " + row.technician?.apellidos : '',
        comercial: row.commercial?.id ? row.commercial?.nombre + " " + row.commercial?.apellidos : '',
        direction: row.direccion || row.propertie?.direccion,
        cp: row.codigoPostal || row.propertie?.codigoPostal,
        municipio: row.municipio || row.propertie?.municipio,
        provincia: row.provincia,
        empleados: (row.trabajadores || row.propertie?.trabajadores) ?? "No",
        servicios: row.gestionadaPor || row.propertie?.gestionadaPor,
        hojasVisita: row.visitSheets,
        visitada: row.visitada || row.propertie?.visitada,
        proveedores: row.suppliersCount,
        docsPendientes: row.hasPendingDocs,
        propCaducadas: row.hasPropCaducadas,
        nuevosSuppsTaaf: row.newSuppsLastWeekTaaf,
        affTaaf:row.source,
        parent_id: row.parent_id,
        // renovarComunidades: row.canRenovate,
      }
    });
  };


  const cambiarFechaEncargo = (nif) => {

    Swal.fire({
      title: t('messages.changeDate'),
      html: `<input type="date" id="fecha" className="swal2-input">`,
      confirmButtonText: t('actions.change'),
      focusConfirm: false,
      preConfirm: () => {
        const fecha = Swal.getPopup().querySelector("#fecha").value;
        if (!fecha) {
          Swal.showValidationMessage(t('messages.insertDate'));
        }
        return { fecha: fecha };
      },
    }).then((result) => {
      let data = {
        nif: nif,
        // fechaEncargo: formatoFechas(result.value.fecha),
      };

      editarAAFF(data)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            toast.success(t('messages.editSuccess'));
          } else {
            let mensajes = [];

            res.data.error.map((err) => {
              mensajes = err;
              toast.error(t('messages.editError'));
            });
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(t('messages.editError'));
        });
    });
  };


  const comunidadesRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.admin'),
      overrideFunc: (data, row) => (
        <Link to={"/aaff/" + row.nif + "/comunidades"}>
          {data}
        </Link>
      )
    },

    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('columns.nif'),
      overrideFunc: (data, row) => row.parent_id ? "" : data
    },
    // {
    //   id: "fechaEncargo",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "FECHA ENCARGO",
    //   overrideFunc: (data, row) => (
    //     <Typography onClick={() => cambiarFechaEncargo(row.nif)} style={{ textAlign: 'left' }}>
    //       {data ? formatoFechasEs(data) : "-"}
    //     </Typography>
    //   ),
    // },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('columns.municipality'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('columns.province'),
    },
    ...(user.rol !== "ADMIN_CAI" ?
    [{
      id: "consultorCae",
      numeric: false,
      disablePadding: false,
      label: t('columns.consultantCae'),
      noObjeto: true,
      overrideFunc: (data, row) => data ? (
        <span
          onClick={() => reasignar(row, "consultor", 1)}
          style={{ cursor: "pointer" }}
        >
          {data}
        </span>
      ) : (
        <Link to={"/aaff/" + row.nif + "/consultor/1"}>
          <div className="asignarButton">
            <img src={Add} alt={t('common:actions.more')} />
            {t('actions.assign')}
          </div>
        </Link>
      )
    },
    {
      id: "consultorLopd",
      numeric: false,
      disablePadding: false,
      label: t('columns.consultantLopd'),
      noObjeto: true,
      overrideFunc: (data, row) => data ? (
        <span
          onClick={() => reasignar(row, "consultor", 2)}
          style={{ cursor: "pointer" }}
        >
          {data}
        </span>
      ) : (
        <Link to={"/aaff/" + row.nif + "/consultor/2"}>
          <div className="asignarButton">
            <img src={Add} alt={t('common:actions.more')} />
            {t('actions.assign')}
          </div>
        </Link>
      )
    },
    {
      id: "comercial",
      numeric: false,
      disablePadding: false,
      label: t('columns.commercial'),
      noObjeto: true,
      overrideFunc: (data, row) => data ? (
        <span
          onClick={() => reasignar(row, "comercial")}
          style={{ cursor: "pointer" }}
        >
          {data}
        </span>
      ) : (
        <Link to={"/aaff/" + row.nif + "/comercial"}>
          <div className="asignarButton">
            <img src={Add} alt={t('common:actions.more')} />
            {t('actions.assign')}
          </div>
        </Link>
      )
    },
    {
      id: "tecnicoCae",
      numeric: false,
      disablePadding: false,
      label: `${t('columns.technician')} CAE`,
      noObjeto: true,
      overrideFunc: (data, row) => data ? (
        <span
          onClick={() => reasignar(row, "tecnico", 1)}
          style={{ cursor: "pointer" }}
        >
          {data}
        </span>
      ) : (
        <Link to={"/aaff/" + row.nif + "/tecnico/1"}>
          <div className="asignarButton">
            <img src={Add} alt={t('common:actions.more')} />
            {t('actions.assign')}
          </div>
        </Link>
      )
    } ]: []),
    ...(user.rol !== "ADMIN_CAI" ?
    [{
      id: "tecnicoCai",
      numeric: false,
      disablePadding: false,
      label: `${t('columns.technician')} CAI`,
      noObjeto: true,
      overrideFunc: (data, row) => data ? (
        <span
          onClick={() => reasignar(row, "tecnico", 3)}
          style={{ cursor: "pointer" }}
        >
          {data}
        </span>
      ) : (
        <Link to={"/aaff/" + row.nif + "/tecnico/3"}>
          <div className="asignarButton">
            <img src={Add} alt={t('common:actions.more')} />
            {t('actions.assign')}
          </div>
        </Link>
      )
    }] : [
      {
        id: "tecnicoCai",
        numeric: false,
        disablePadding: false,
        label: `${t('columns.technician')} CAI`,
      }
    ]),
    ...(user.rol !== "ADMIN_CAI" ?
    [{
      id: "tecnicoKae",
      numeric: false,
      disablePadding: false,
      label: `${t('columns.technician')} KAE`,
      noObjeto: true,
      overrideFunc: (data, row) => data ? (
        <span
          onClick={() => reasignar(row, "tecnico", 4)}
          style={{ cursor: "pointer" }}
        >
          {data}
        </span>
      ) : (
        <Link to={"/aaff/" + row.nif + "/tecnico/4"}>
          <div className="asignarButton">
            <img src={Add} alt={t('common:actions.more')} />
            {t('actions.assign')}
          </div>
        </Link>
      )
    },
    // {
    //   id: "comunidades",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "COMUNIDADES",
    //   overrideFunc: (row) => (
    //     <Typography>
    //       {row}
    //     </Typography>
    //   ),
    // },
    {
      id: "comunidadesVisitadas",
      numeric: false,
      disablePadding: false,
      label: t('columns.visitedCommunities'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <ProgressBarWithColors
          value={data}
          label={
            <Typography>
              {row.visitadasCount} /{" "}
              {row.pendientesCount + row.visitadasCount}
            </Typography>
          }
        />
      ),
    },
    {
      id: "comunidadesRenovasVisitadas",
      numeric: false,
      disablePadding: false,
      label: t('columns.renewedVisitedCommunities'),
      noObjeto: true,
      overrideFunc: (data, row) =>
      (
        <ProgressBarWithColors
          value={data}
          label={
            <Typography>
              {row.renovadasVisitadasCount} /{" "}
              {row.renovadasCount + row.renovadasVisitadasCount}
            </Typography>
          }
        />
      ),
    },
    {
      id: "proveedores",
      numeric: false,
      disablePadding: false,
      label: t('columns.suppliers'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Link to={"/aaff/" + row.nif + "/proveedores"}>
          {data}
        </Link>
      )
    },
    // {
    //   id: "propCaducadas",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "",
    //   noObjeto: true,
    //   overrideFunc: (data) => (
    //     <>
    //       {data ?
    //         <Tooltip title="Hay comunidades caducadas" arrow>
    //           <img src={criticalWarning} width={15} alt="comunidades caducadas" />
    //         </Tooltip>
    //         : null}
    //     </>
    //   ),
    // },
    {
      id: "docsPendientes",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data, row) => (
        <div style={{ display: 'flex' }}>
          {row.propCaducadas ?
            <Tooltip title={t('tooltips.expiredCommunities')} arrow>
              <img src={criticalWarning} style={{ margin:2}} width={15} alt="comunidades caducadas" />
            </Tooltip>
          : null}
          {data ?
              <Link to={"/aaff/" + row.nif + "/proveedores?hasPendingDocs=true"}>
                <Tooltip title={t('tooltips.pendingDocs')} arrow>
                  <img src={Warning} style={{ margin:2}} width={15} alt="pendientes" />
                </Tooltip>
              </Link>
          : null}
        </div>
      ),
    },
    {
      id: "nuevosSuppsTaaf",
      numeric: false,
      disablePadding: false,
      label: t('columns.sync'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <div style={{ display: 'flex' }}>
          {row.nuevosSuppsTaaf > 0 ?
          <Link to={`/proveedores?source=taaf&aaff_source=${row.id}`}>
            <Tooltip title={t('tooltips.viewSyncSuppliers')} arrow>
              <div>
                <FaEye style={{ fontSize: '1.2rem' }} />
              </div>
            </Tooltip>
          </Link>
          : null
          }
        </div>
      ),
    },
    {
      id: "affTaaf",
      numeric: false,
      disablePadding: false,
      label: t('columns.source'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <div style={{ display: 'flex' }}>
        {row.affTaaf}
        </div>
      ),
    },
    {
      id: "login",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Tooltip title={t('actions.loginAs')}>
          <div className="bigBtn p-2" onClick={() => loginAsAAFF(row.nif)}>
            <Login fontSize="small" />
          </div>
        </Tooltip>
      )
    }] : []),
    // {
    //   id: "renovarComunidades",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "RENOVAR COMUNIDADES",
    //   overrideFunc: (data, row) =>
    //     data ? (
    //       <Button className="btn-Secondary" variant="contained" color="secondary">
    //         <Link to={`/aaff/${row.nif}/renovar`} target={"_blank"} >Renovar</Link>
    //       </Button>
    //     ) : (
    //       <img src={Tick} width="30px" alt="todas renovadas" />
    //     ),
    // },
  ];


  const filtrarDatos = (filtros) => {
    setBusqueda(filtros);
    setBusquedaActiva(true);
    // fetchData();
  }

  useEffect(() => {
      return () => {
        if (refControladorAborto.current) {
          refControladorAborto.current.abort();
        }
      };
    }, []);

  return (
    <>
      <BreadCrumb rutas={[{ path: "/aaff", label: t('title') }]} style={{ margin: "0 10px" }} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">{t('title').toUpperCase()}</div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        {user.rol !== "ADMIN_CAI" && (
        <div className="contentBar">
          <div className="contentBtns"></div>
          <Link to="/aaff/nuevo" target={"_blank"}>
            <div className="contentButton">
              <img src={Add} alt={t('common:actions.more')} />
            </div>
          </Link>
        </div>
        )}
        <FiltrosAAFF onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} />
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={comunidadesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('messages.noAaff')}
                enumerate={true}
              />
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};

export default withRouter(AAFF);
